import { useState } from 'react';

export default function useAdoptionForm() {
  const WORKER_URL = import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_CONTACT_FORM;

  const [form, setForm] = useState({
    which_dog: '',
    name: '',
    email: '',
    phone: '',
    year_of_birth: '',
    country: '',
    country_code: '',
    city: '',
    address_neighborhood: '',
    apartment_or_house: '',
    property_owned: '',
    yard_garden: '',
    occupation: '',
    hours_away: '',
    had_dog: '',
    other_animals: '',
    household_people: '',
    time_devoted: '',
    sleeping_place: '',
    why_adopt: '',
    vet_costs: '',
    behavioral_problems: '',
    vacation: '',
    life_changes: '',
    how_soon: '',
    meet_saturday: '',
    sign_contract: '',
    send_updates: '',
    ready_to_sterilize: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendEmail = async (recaptchaToken, labels) => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Build a custom message string following the order of provided labels
      const messageTokens = [];
      for (const key of Object.keys(labels)) {
        const value = form[key];
        messageTokens.push(`${labels[key]}: ${value || '-'}`);
      }
      const dogNameLine = form.which_dog
        ? `Naziv psa: ${form.which_dog} \n\n`
        : '';
      const message = dogNameLine + messageTokens.join('\n\n');

      const payload = {
        name: form.name,
        email: form.email,
        subject: `Adoption form - ${form.which_dog}`,
        country_code: form.country_code,
        message: message,
        recaptchaToken,
      };

      // console.log('[AdoptionForm] Sending payload:', payload);

      const res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      // console.log('[AdoptionForm] Worker response:', res.status, JSON.stringify(data));

      if (!res.ok) {
        throw new Error(data.error || 'Greška prilikom slanja emaila.');
      }

      setSuccess('Poruka je uspješno poslana!');
      setForm({
        which_dog: '',
        name: '',
        email: '',
        phone: '',
        year_of_birth: '',
        country: '',
        country_code: '',
        city: '',
        address_neighborhood: '',
        apartment_or_house: '',
        property_owned: '',
        yard_garden: '',
        occupation: '',
        hours_away: '',
        had_dog: '',
        other_animals: '',
        household_people: '',
        time_devoted: '',
        sleeping_place: '',
        why_adopt: '',
        which_dog: '',
        vet_costs: '',
        behavioral_problems: '',
        vacation: '',
        life_changes: '',
        how_soon: '',
        meet_saturday: '',
        sign_contract: '',
        send_updates: '',
        ready_to_sterilize: '',
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    setForm,
    loading,
    error,
    success,
    handleChange,
    sendEmail,
    setError,
    setSuccess,
  };
}
